<template>
        <v-row justify="center">
            <v-dialog
                v-show="DialogAviso"
                v-model="DialogAviso"
                max-width="800"
            >
                <v-card>
                    <!-- headline text-uppercase hidden-sm-and-down -->
                    <v-card-title class="headline justify-center">
                        Aviso de privacidad
                    </v-card-title>
                    <v-card-text>
                        La Universidad de Guanajuato (órgano autónomo, con personalidad jurídica y patrimonio propio de conformidad a lo dispuesto por el decreto emitido por el H. Congreso del Estado de Guanajuato en fecha 11 de mayo de 1994; cuyos fines son educar, investigar y difundir la cultura, determinar sus planes y programas; así como fijar los términos de ingreso, promoción y permanencia de su personal y administrar su patrimonio) a través de la Dirección de Igualdad y Corresponsabilidad Social, es responsable de proteger los datos personales.
                        <v-spacer />
                        Los datos que recabamos de usted y de su organización serán utilizados para las siguientes finalidades:
                        <v-spacer />
                        a) Integrar el catálogo de proyectos de voluntariado, disponible para las y los estudiantes de la Universidad de Guanajuato, quienes podrán establecer contacto y vincularse con su organización. Se utilizará únicamente el nombre comercial de la organización, nombre del responsable del proyecto en la organización, teléfono y correo electrónico de contacto.
                        <v-spacer />
                        b) Establecer comunicación entre estudiantes y personal de la Dirección de Igualdad y Corresponsabilidad Social, con el responsable del proyecto de voluntariado en la organización, a efectos de garantizar y mejorar la operación y participación de los estudiantes.
                        <v-spacer />
                        c) Realizar un informe estadístico de la participación de las y los estudiantes en los proyectos de voluntariado.
                        <v-spacer />
                        Se hace de su conocimiento que sus datos personales podrán ser transmitidos a otros sujetos obligados siempre y cuando los datos se utilicen para el ejercicio de facultades propias de los mismos, además de otras transmisiones previstas en la Ley.
                        <v-spacer />
                        La Dirección de Igualdad y Corresponsabilidad Social pondrá a consideración del ciudadano, a través de un manifiesto expreso, la autorización o no de la transferencia de sus datos personales a otros sujetos obligados, cuyo tratamiento sea susceptible de transferencia.
                        <v-spacer />
                        El aviso de privacidad podrá ser consultado en la página institucional en Internet: <a>http://www.transparencia.ugto.mx/index.php/publico/privacidad</a> y <a>http://www.ugto.mx/serviciosocial</a>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            color="green darken-1"
                            text
                            @click="DialogAviso = false"
                        >
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
</template>
<script>
export default {
    name: 'AvisoPrivacidadSS',
     data () {
    return {
      DialogAviso: true
    };
  }
}
</script>